// @ts-nocheck
import * as $ from 'jquery';
import { AddDepartmentToCartRequest, AddToCartRequest } from './Models/AddToCartRequest';

export class EmployeeSection {
    private apiUrl: string;
    private employeeListTableBody: JQuery;
    private loader: JQuery;
    private pageSize: number;
    private filterDepartment: JQuery;
    private filterServices: JQuery;
    private searchEmployeesInput: JQuery;
    private addSelectedEmployeesButton: JQuery;
    private isSearching: boolean;
    private timeout: any;
    private pickEmployeesArea: JQuery;
    private choosenEmployeesArea: JQuery;
    private addEmployeeToCart: (request: AddToCartRequest) => any;
    private addDepartmentToCart: (request: AddDepartmentToCartRequest) => any;
    private runCheckout: () => any;
    private readonly updateSelectedList: () => any;
    private tableArea: JQuery;

    constructor(private container: JQuery, apiUrl: string,
            addEmployeeToCartCallback: (request: AddToCartRequest) => any,
            addDepartmentToCartCallback: (request: AddDepartmentToCartRequest) => any,
            updateSelectedListCallback: () => any,
            runCheckoutCallback: () => any) {
        this.apiUrl = apiUrl;
        this.pageSize = 100000;
        this.tableArea = container.find('.employee-list');
        this.employeeListTableBody = container.find('#employee-list-tbody');
        this.employeeListTableBody
            .on('click', '.service-checkbox', (event) => this.clickCheckBox(event));
        this.filterDepartment = container.find('#FilterDepartment');
        this.loader = container.find('.section-loader');
        this.loader.hide();
        this.filterServices = container.find('#EmployeeServiceFilter');
        this.searchEmployeesInput = container.find('#Search');
        this.addSelectedEmployeesButton = container.find('.add-selected-employees-button');
        this.addEmployeeToCart = addEmployeeToCartCallback;
        this.addDepartmentToCart = addDepartmentToCartCallback;
        this.updateSelectedList = updateSelectedListCallback;
        this.runCheckout = runCheckoutCallback;
        this.pickEmployeesArea = $('.pick-employees');
        this.choosenEmployeesArea = $('.choosen-employees');
        this.initialize();

        // Show initial list of employees
        this.searchEmployees();
    }

    initialize(): void {
        this.searchEmployeesInput.on('keyup', (event) => this.searchChanged(event));
        this.filterDepartment.on('change', (event) => this.searchChanged(event));
        this.filterServices.on('change', (event) => this.searchChanged(event));
        this.addSelectedEmployeesButton.on('click', (event) => this.addSelectedEmployees(event));
        this.tableArea.on('click', '.load-more', () => this.showAll());
    }

    searchChanged(evt: JQueryEventObject): void {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.searchEmployees();
    }

    searchEmployees(append?: boolean, page?: number): void {
        if (!this.isSearching) {
            const section = this;
            let query = section.searchEmployeesInput.val();
            let department = section.filterDepartment.val();
            let serviceFilter = section.filterServices.val();
            const pageSize = section.pageSize;

            this.timeout = setTimeout(function () {
                let searchUrl = section.apiUrl +
                    `?ps=${pageSize}&d=${department}`;
                if (page) {
                    searchUrl += `&p=${page}`;
                }

                if (query && query.length > 2) {
                    searchUrl += `&q=${query}`;
                }

                if (serviceFilter && serviceFilter !== '' && serviceFilter.length > 0) {
                    searchUrl += `&sf=${serviceFilter}`;
                }

                section.isSearching = true;
                section.loader.show();

                if (!append) {
                    section.employeeListTableBody.empty();
                }
                $.ajax({
                    url: searchUrl,
                    dataType: 'json',
                    success: function (data) {
                        if (data.Items && data.Items.length >= 0) {
                            let i;

                            if (data.Items.length <= 1000) {
                                let allRow = section.createSelectAllRow();
                                section.employeeListTableBody.append(allRow);
                            }

                            for (i = 0; i < data.Items.length; i = i + 1) {
                                let employee = data.Items[i];
                                let row = section.createEmployeeRow(employee);
                                section.employeeListTableBody.append(row);
                            }
                        }
                        section.loader.hide();
                        section.isSearching = false;
                        section.showThe10First();
                    }
                });
            });
        }
    }

    showThe10First() {
        this.tableArea.find('.show-more-button').remove();
        this.employeeListTableBody.removeClass('showAll');
        let button = $('<button class="btn btn-default btn-contained right load-more">')
            .html('Vis mer');
        let messageRow = $('<div class="show-more-button" />').append(button);
        this.tableArea.append(messageRow);
    }

    showAll() {
        this.employeeListTableBody.addClass('showAll');
        this.tableArea.find('.show-more-button').remove();
    }

    createSelectAllRow(): JQuery {
        let row = $('<tr data-adjust-all />');
        row.append($('<td/>').text('Alle'));
        row.append($('<td/>'));
        row.append($('<td/>'));
        row.append($('<td class="services" />').html(this.getServiceCheckbox(false, true)));
        return row;
    }

    createDepartmentRow(departmentName: string, departmentId: string): JQuery {
        let row = $(`<tr data-department-id='${departmentId}' data-department-name='${departmentName}' />`);
        row.append($('<td/>'));
        row.append($('<td/>').text(departmentName));
        row.append($('<td/>'));
        row.append($('<td class="services" />').html(this.getServiceCheckbox(false)));
        return row;
    }

    createEmployeeRow(employee: any): JQuery {
        let row = $(`<tr data-employee-name='${employee.FirstName + ' ' +
            employee.LastName}' data-employee-department='${employee.DepartmentName} +
            ' data-employee-phonenumber='${employee.PhoneNumber}' data-employee-id='${employee.Id}' +
            ' data-has-ticket-app='${employee.HasTicketApp}' +
            ' data-has-changed='false' />`);
        row.append($('<td/>').text(employee.FirstName + ' ' + employee.LastName));
        row.append($('<td/>').text(employee.DepartmentName));
        row.append($('<td/>').text(employee.PhoneNumber));
        row.append($('<td class="services" />').html(this.getServiceCheckbox(employee.HasTicketApp)));
        return row;
    }

    private getServiceCheckbox(checked: boolean, isSelectAll?: boolean) {
        return `<input type="checkbox" class="service-checkbox" ${checked ? 'checked' : ''} ${isSelectAll ? 'data-adjust-all' : ''} />`;
    }

    checkEnableSaveButton(): void {
        const result = this.getEmployeesToAdd();
        if (result.length > 0) {
            this.addSelectedEmployeesButton.prop('disabled', false);
        } else {
            this.addSelectedEmployeesButton.prop('disabled', true);
        }
    }

    getEmployeesToAdd(): JQuery {
        return this.getAllEmployeeRows().not('[data-adjust-all]').filter(function() {
            return $(this).data('has-changed') === true;
        });
    }

    getAllEmployeeRows(): JQuery {
        return this.employeeListTableBody.find('tr');
    }

    getAdjustAllRows(): JQuery {
        return this.employeeListTableBody.find('[data-adjust-all]');
    }

    clickCheckBox(evt: JQueryEventObject): void {
        let target = $(evt.currentTarget);
        let type = 'add';
        let tr = target.closest('tr');

        if (target.is('[data-adjust-all]')) {
            this.loader.show();
            this.selectAll(target, type);
        } else {
            tr.data('has-changed', true);
        }

        this.checkEnableSaveButton();
    }

    selectAll(checkbox: JQuery, type: string) {
        let container = checkbox.parent();
        let value = checkbox.is(':checked');
        let trs = container.closest('tbody').find('tr');

        let section = this;
        trs.not('[data-adjust-all]').each(function () {
            $(this).data('has-changed', true);
            $(this).find('input.service-checkbox').prop('checked', value);
        });

        section.checkEnableSaveButton();
        section.loader.hide();
    }

    addSelectedEmployees(evt: JQueryEventObject): void {
        this.pickEmployeesArea.hide();
        this.choosenEmployeesArea.show();
        this.loader.show();
        const result = this.getEmployeesToAdd();
        let section = this;
        result.each(function () {
            let employeeId = $(this).data('employee-id');
            let departmentId = $(this).data('department-id');
            let department = $(this).data('employee-department');
            if (employeeId) {
                let phoneNumber = $(this).data('employee-phonenumber');
                let name = $(this).data('employee-name');
                let hasTicketApp = 
                        ($(this).find('.service-checkbox')[0] as HTMLInputElement).checked;

                section.addEmployeeToCart(
                    new AddToCartRequest(employeeId, name, department, phoneNumber, hasTicketApp));
            } else if (departmentId) {
                let name = $(this).data('department-name');
                section.addDepartmentToCart(new AddDepartmentToCartRequest(departmentId, name));
            }

            // Reset row
            section.resetRow($(this));
        });

        let allRows = this.getAdjustAllRows();
        allRows.each(function () {
            section.resetRow($(this));
        });

        this.updateSelectedList();
        this.checkEnableSaveButton();
        this.loader.hide();
        this.resetSection();
        this.runCheckout();
    }

    resetRow(row: JQuery): void {
        row.find('input.service-checkbox[type="checkbox"]:checked').prop('checked', false);
    }

    private resetSection() {
        this.filterServices.val('');
        this.filterDepartment.val('');
        this.searchEmployeesInput.val('');
        this.employeeListTableBody.html();
    }
}
